import { dashboardActions } from "../../constants/actionTypes";

const getData = () => ({
  type: dashboardActions.apiAction,
});

const setData = (data) => ({
  type: dashboardActions.apiActionSet,
  payload: data,
});

const setError = (data) => ({
  type: dashboardActions.apiActionError,
  payload: data,
});

const getResourceProviderListDashboard = (data) => ({
  type: dashboardActions.getResourceProviderDashboard,
  payload: data,
});

const resourceProviderListDashboardSuccess = (data) => ({
  type: dashboardActions.resourceProviderDashboardSuccess,
  payload: data,
});

const resourceProviderListDashboardError = (data) => ({
  type: dashboardActions.resourceProviderDashboardError,
  payload: data,
});

const resetResourceProviderListDashboard = (data) => ({ type: dashboardActions.resetProviderList, payload: data });
const getResourcesInfoDashboard = (data) => ({ type: dashboardActions.getResourcesInfoDashboard, payload: data });

const resourcesInfoDashboardSuccess = (data) => ({ type: dashboardActions.resourcesInfoDashboardSuccess, payload: data });
const resourcesInfoDashboardError = (data) => ({ type: dashboardActions.resourcesInfoDashboardError, payload: data });
const getTenantStatsDashboard = (data) => ({ type: dashboardActions.getTenantsStatsDashboard, payload: data });
const tenantDashboardSuccess = (data) => ({ type: dashboardActions.tenantDashboardSuccess, payload: data });
const tenantDashboardError = (data) => ({ type: dashboardActions.tenantDashboardError, payload: data });
const getUserStatsDashboard = (data) => ({ type: dashboardActions.getUserStatsDashboard, payload: data });
const userDashboardSuccess = (data) => ({ type: dashboardActions.userDashboardSuccess, payload: data });
const userDashboardError = (data) => ({ type: dashboardActions.userDashboardError, payload: data });
const getUserDropdownDashboard = (data) => ({ type: dashboardActions.getUserDropDownDashboard, payload: data });
const userDropdownListDashboardSuccess = (data) => ({ type: dashboardActions.userDropdownDashboardSuccess, payload: data });
const userDropdownListDashboardError = (data) => ({ type: dashboardActions.userDropdownDashboardError, payload: data });

const getPendingActionsDashboard = (data) => ({ type: dashboardActions.getPendingActions, payload: data });
const pendingActionsDashboardSuccess = (data) => ({ type: dashboardActions.pendingActionsDashboardSuccess, payload: data });
const pendingActionsDashboardError = (data) => ({ type: dashboardActions.pendingActionsDashboardError, payload: data });

const setUsersListSearching = (data) => ({ type: dashboardActions.usersListSearching, payload: data });
const setLoadingDashboard = (data) => ({
  type: dashboardActions.setLoadingDashboard,
  payload: data,
});
const setLoadingResourcesDashboard = (data) => ({
  type: dashboardActions.setloadingResourcesInfo,
  payload: data,
});
const setResProviderListLoading = (data) => ({ type: dashboardActions.setResProviderListLoading, payload: data });
const setLoadingDashboardTenStats = (data) => ({ type: dashboardActions.setLoadingDashboardTenStats, payload: data });
const setLoadingDashboardUserStats = (data) => ({ type: dashboardActions.setLoadingDashboardUserStats, payload: data });
const setPendingActionLoading = (data) => ({ type: dashboardActions.setPendingActionLoading, payload: data });

const getVMStatsDashboard = (data) => ({ type: dashboardActions.getVMStats, payload: data });
const vmStatsDashboardSuccess = (data) => ({ type: dashboardActions.vmStatsSuccess, payload: data });
const getVMStatsTenantUserDashboard = (data) => ({ type: dashboardActions.getVMStatsTenantUserDashboard, payload: data });
const vmStatsDashboardError = (data) => ({ type: dashboardActions.vmStatsError, payload: data });
const setLoadingDashboardVMStats = (data) => ({ type: dashboardActions.setLoadingDashboardVMStats, payload: data });

const setLoadingDashboardLastBillingInfo = (data) => ({ type: dashboardActions.setLoadingDashboardBillingInfoLast, payload: data });
const setLoadingDashboardCurrBillingInfo = (data) => ({ type: dashboardActions.setLoadingDashboardBillingInfoCurr, payload: data });
const getDashboardBillingCurrStats = (data) => ({ type: dashboardActions.getBillingStatsDashboardCurrMonth, payload: data });
const getDashboardBillingLastStats = (data) => ({ type: dashboardActions.getBillingStatsDashboardLastMonth, payload: data });
const billingStatsCurrMonthDashboardSuccess = (data) => ({ type: dashboardActions.billingStatsCurrMonthDashboardSuccess, payload: data });
const billingStatsLastMonthDashboardSuccess = (data) => ({ type: dashboardActions.billingStatsLastMonthDashboardSuccess, payload: data });
const billingStatsDashboardError = (data) => ({ type: dashboardActions.billingStatsDashboardError, payload: data });

const setLoadingDashAllVMs = (data) => ({ type: dashboardActions.setLoadingAllVMs, payload: data });
const getDashAllVMs = (data) => ({ type: dashboardActions.getAllVMs, payload: data });
const AllVMsDashSuccess = (data) => ({ type: dashboardActions.ALLVMsDashboardSuccess, payload: data });
const AllVMsDashError = (data) => ({ type: dashboardActions.ALLVMsDashboardError, payload: data });
const UpdateDashboardVMState = (data) => ({ type: dashboardActions.UPDATE_DASHBOARD_VM_STATE, payload: data });

const setLoadingDashTrendingLabs = (data) => ({ type: dashboardActions.setLoadingAllTrendLabs, payload: data });
const getDashTrendingLabs = (data) => ({ type: dashboardActions.getAllTrendingLabs, payload: data });
const ALLTrendingLabsDashSuccess = (data) => ({ type: dashboardActions.ALLTrendingLabsDashboardSuccess, payload: data });
const ALLTrendingLabsDashError = (data) => ({ type: dashboardActions.ALLTrendingLabsDashboardError, payload: data });

const setLoadingUsageTrends = (data) => ({ type: dashboardActions.setLoadingUsageTrends, payload: data });
const getDashboardUsageDailyTrends = (data) => ({ type: dashboardActions.getDashboardUsageDailyTrends, payload: data });
const getDashboardUsageWeeklyTrends = (data) => ({ type: dashboardActions.getDashboardUsageWeeklyTrends, payload: data });
const UsageTrendsDashboardDailySuccess = (data) => ({ type: dashboardActions.usageTrendsDashboardDailySuccess, payload: data });
const UsageTrendsDashboardWeeklySuccess = (data) => ({ type: dashboardActions.usageTrendsDashboardWeeklySuccess, payload: data });
const usageTrendsDashboardError = (data) => ({ type: dashboardActions.usageTrendsDashboardError, payload: data });

const setLoadingUsageHours = (data) => ({ type: dashboardActions.setLoadingUsageHours, payload: data });
const getDashboardUsageHours = (data) => ({ type: dashboardActions.getDashboardUsageHours, payload: data });
const UsageHoursDashboardSuccess = (data) => ({ type: dashboardActions.UsageHoursDashboardSuccess, payload: data });
const UsageHoursDashboardError = (data) => ({ type: dashboardActions.UsageHoursDashboardError, payload: data });

const setLoadingForecast = (data) => ({ type: dashboardActions.setLoadingForecast, payload: data });
const getDashboardForecast = (data) => ({ type: dashboardActions.getDashboardForecast, payload: data });
const ForecastDashboardSuccess = (data) => ({ type: dashboardActions.forecastDashboardSuccess, payload: data });
const ForecastDashboardError = (data) => ({ type: dashboardActions.forecastDashboardError, payload: data });

const resouceProviderCountLoading = (data) => ({
  type: dashboardActions.RESOURSE_PROVIDER_COUNT_LOADING,
  payload: data,
});
const resouceProviderCountAction = (data) => ({
  type: dashboardActions.RESOURSE_PROVIDER_COUNT_ACTION,
  payload: data,
});
const resouceProviderCountSuccess = (data) => ({
  type: dashboardActions.RESOURSE_PROVIDER_COUNT_SUCCESS,
  payload: data,
});
const resouceProviderCountError = (data) => ({
  type: dashboardActions.RESOURSE_PROVIDER_COUNT_ERROR,
  payload: data,
});

export {
  getData,
  setData,
  setError,
  getResourceProviderListDashboard,
  resourceProviderListDashboardSuccess,
  resourceProviderListDashboardError,
  getResourcesInfoDashboard,
  resourcesInfoDashboardSuccess,
  resourcesInfoDashboardError,
  setLoadingDashboard,
  setLoadingResourcesDashboard,
  getTenantStatsDashboard,
  tenantDashboardSuccess,
  tenantDashboardError,
  getUserStatsDashboard,
  userDashboardSuccess,
  userDashboardError,
  getUserDropdownDashboard,
  userDropdownListDashboardSuccess,
  userDropdownListDashboardError,
  setUsersListSearching,
  getPendingActionsDashboard,
  pendingActionsDashboardSuccess,
  pendingActionsDashboardError,
  setResProviderListLoading,
  setLoadingDashboardTenStats,
  setLoadingDashboardUserStats,
  setPendingActionLoading,
  getVMStatsDashboard,
  vmStatsDashboardSuccess,
  vmStatsDashboardError,
  setLoadingDashboardVMStats,
  getVMStatsTenantUserDashboard,
  resetResourceProviderListDashboard,
  setLoadingDashboardLastBillingInfo,
  setLoadingDashboardCurrBillingInfo,
  getDashboardBillingLastStats,
  getDashboardBillingCurrStats,
  billingStatsCurrMonthDashboardSuccess,
  billingStatsLastMonthDashboardSuccess,
  billingStatsDashboardError,
  setLoadingDashAllVMs,
  getDashAllVMs,
  AllVMsDashSuccess,
  AllVMsDashError,
  setLoadingDashTrendingLabs,
  getDashTrendingLabs,
  ALLTrendingLabsDashSuccess,
  ALLTrendingLabsDashError,
  setLoadingUsageTrends,
  getDashboardUsageDailyTrends,
  getDashboardUsageWeeklyTrends,
  UsageTrendsDashboardDailySuccess,
  UsageTrendsDashboardWeeklySuccess,
  usageTrendsDashboardError,
  setLoadingUsageHours,
  getDashboardUsageHours,
  UsageHoursDashboardSuccess,
  UsageHoursDashboardError,
  UpdateDashboardVMState,
  ForecastDashboardError,
  ForecastDashboardSuccess,
  getDashboardForecast,
  setLoadingForecast,
  resouceProviderCountLoading,
  resouceProviderCountAction,
  resouceProviderCountSuccess,
  resouceProviderCountError,
};
